import { ACCOUNT_TYPE } from '.';

export enum PAGE_ROUTE {
	HOME = '/',
	LOGIN = '/login',
	NOT_FOUND = '/404',
	COMMING_SOON = '/comming-soon',
	ACCOUNT_TYPE = '/select-account-type',
	FORGOT_PASSWORD = '/forgot-password',
	FORGOT_PASSWORD_EMAIL = '/forgot-password-email',
	CHANGE_FORGOTTEN_PASS = '/change-forgotten-pass',
	REGISTRATION = '/registration',
	OTP = '/otp',
	DASHBOARD = '/dashboard',
	DASHBOARD_ACCOUNT = '/account',
	DASHBOARD_CHANGE_REQUEST = '/change-request',
	DASHBOARD_INVESTMENT = '/investment',
	DASHBOARD_GUARANTEE = '/guarantee',
	DASHBOARD_MORTGAGE = '/mortgage',

	MORTGAGE_DEALS = '/mortgage-deals',
	CONTRACT_US = '/contact-us',

	DASHBOARD_GUARANTEE_INVITATION = '/guarantor-invitation',
	DASHBOARD_VIEW_GUARANTEE = '/guarantee/view',
	DASHBOARD_SUBMIT_GUARANTEE = '/guarantee/submit',

	FUNDER = '/funder',
	FUNDER_ACCOUNT = '/funder/account',
	FUNDER_REQUEST_FORM = '/funder/individual/request-form',
	FUNDER_COMPANY = '/funder/company',
	FUNDER_COMPANY_REQUEST_FORM = '/funder/company/request-form',

	BORROWER = '/borrower',
	BORROWER_ACCOUNT = '/borrower/account',
	BORROWER_ACCOUNT_FORM = '/borrower/individual/request-form',
	BORROWER_COMPANY = '/borrower/company',
	BORROWER_COMPANY_REQUEST = '/borrower/company/request-form',

	MORTGAGE_DEAL_FORM = '/mortgage-deal/individual/request-form',
	MORTGAGE_DEAL_CORPORATE_FORM = '/mortgage-deal/corporate/request-form',
	MORTGAGE_DEAL_DETAIL = '/mortgage-deal-detail',

	VIEW_MORTGAGE_DEAL_FORM = '/mortgage-deal/view-mortgage-deal-form',

	DASHBOARD_GUARANTEE_VIEW_DOCUMENT = '/guarantee/view-document',

	DASHBOARD_MORTGAGE_OFFER_LETTER = '/mortgage-offer',
	DASHBOARD_MORTGAGE_OFFER_LETTER_PREVIEW = '/mortgage-offer-preview',

	OFFER_PAYMENT_RESULT_PATH = '/payment-result',

	BORROWER_SELECT_PROPOSAL = '/deal-proposal-list',
	FUNDER_VIEW_PENDING_ACCEPTANCE_DEAL = '/view-pending-acceptance-deal',
}

export enum PAGE_ROUTE_PATH_VARIABLE {
	REGISTRATION = 'accountType',
	FORGOT_PASSWORD_TOKEN = 'token'
}

export const LIST_PATH_NOT_SHOW_ERROR_MESSAGE = ['/forgot-password'];

export const PAGE_ROUTE_WITH_PATH = {
	REGISTRATION: PAGE_ROUTE.REGISTRATION.concat('/:').concat(PAGE_ROUTE_PATH_VARIABLE.REGISTRATION),
	CORPORATE_REGISTRATION: PAGE_ROUTE.REGISTRATION.concat('/').concat(ACCOUNT_TYPE.CORPORATE),
	INDIVIDUAL_REGISTRATION: PAGE_ROUTE.REGISTRATION.concat('/').concat(ACCOUNT_TYPE.INDIVIDUAL),
	CHANGE_FORGOTTEN_PASS: PAGE_ROUTE.CHANGE_FORGOTTEN_PASS.concat('/:').concat(
		PAGE_ROUTE_PATH_VARIABLE.FORGOT_PASSWORD_TOKEN
	)
};

export const disallowBackRouteList: PAGE_ROUTE[] = [
	PAGE_ROUTE.BORROWER_COMPANY_REQUEST,
	PAGE_ROUTE.BORROWER_ACCOUNT_FORM,
	PAGE_ROUTE.FUNDER_COMPANY_REQUEST_FORM,
	PAGE_ROUTE.FUNDER_REQUEST_FORM,
	PAGE_ROUTE.FUNDER_ACCOUNT,
	PAGE_ROUTE.FUNDER_COMPANY,
	PAGE_ROUTE.BORROWER_ACCOUNT,
	PAGE_ROUTE.BORROWER_COMPANY,
	PAGE_ROUTE.DASHBOARD
];